<script>
export default {
    data() {
        return {

        }
    },
    created: function () {
        let posid=localStorage.getItem("posid");
        let staffid=localStorage.getItem("staffid");
        let storeid=localStorage.getItem("storeid");
        if("0eb084d90a5a418badbef57939b385ba"==posid || "f07a0f8c14e047589c18d04e4e3f6f37"==posid || "59a8ebde51ae416ab1d149e1d968de5b"==posid
            || "bd4e1d2543e84bf0a16eba8ff6af0151"==posid){
            this.$router.push({path:"/beautystafftabbar",query:{
                    staffid:staffid,
                }});
        }
        else if("d6511059fec84700a91a86e43436fd58"==posid || "ceb744d8bb9747849b3c7e997d0df357"==posid
            || "9132ffd069fd494687c1c9bc929baf5d"==posid || "07434c86082d482cb5e3a9a8a5b8dbe8"==posid){
            this.$router.push("/beautygrid");
        }
        else if("b7781c4e3f9249d9b3c5d2f1a183eae5"==posid || "94cbd462f6494dd79dcfc5ebe2e43c43"==posid){
            this.getStoreByStructsByStaffId(storeid,staffid);
        }
        else{
            window.close();
        }
        /*let userId = this.getUrlKey("userId");
        let code = this.getUrlKey("code");
        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getCorpidCode?state=15";
        }*/
    },
    methods:{
        getStoreByStructsByStaffId(storeid,staffid){
            this.$post("store/getStoreByStructsByStaffId",{storeid:storeid,staffid:staffid}).then(res=>{
                if(res.sucess){
                    localStorage.setItem("storeid",res.object[0].brandid);
                    localStorage.setItem("parentstoreid",res.object[0].brandid);
                    this.$router.push("/beautygrid");
                }
                else{
                    this.$message.error(res.message);
                }
            });
        },
        getCorpUserInfo(staffid){
            this.$post("wechat/getCorpUserInfo",{staffid:staffid}).then(res=>{
                if(res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        localStorage.setItem("storename",data.staff.storename);
                        localStorage.setItem("storeid",data.staff.storeid);
                        localStorage.setItem("parentstoreid",data.staff.storeid);
                        let posid=data.staff.posid;
                        if("0eb084d90a5a418badbef57939b385ba"==posid || "f07a0f8c14e047589c18d04e4e3f6f37"==posid || "59a8ebde51ae416ab1d149e1d968de5b"==posid
                            || "bd4e1d2543e84bf0a16eba8ff6af0151"==posid){
                            this.$router.push({path:"/beautystafftabbar",query:{
                                    staffid:data.staff.staffid,
                                }});
                        }
                        else if("d6511059fec84700a91a86e43436fd58"==posid || "ceb744d8bb9747849b3c7e997d0df357"==posid
                            || "9132ffd069fd494687c1c9bc929baf5d"==posid || "07434c86082d482cb5e3a9a8a5b8dbe8"==posid){
                            this.$router.push("/beautygrid");
                        }
                        else if("b7781c4e3f9249d9b3c5d2f1a183eae5"==posid || "94cbd462f6494dd79dcfc5ebe2e43c43"==posid){
                            this.getStoreByStructsByStaffId(data.staff.storeid,data.staff.staffid);
                        }
                        else{
                            window.close();
                        }
                        //this.getOrderInfoByFromdateTo();
                    }
                }
                else{
                    window.close();
                }
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/page/beauty/beautyloginnew.vue